/**
 * 自营大屏数据接口
 */
export default {
  BASE_URL: '/index',
  api: [
    {
      name: 'getScreen',
      desc: '首页数据大屏统计',
      method: 'GET',
      path: '/getScreen'
    },
    {
      name: 'getOrderPlace',
      desc: '下单流水屏',
      method: 'GET',
      path: '/getOrderPlace'
    },
    {
      name: 'getSelfAmountRecent',
      desc: '近七天自营交易额',
      method: 'GET',
      path: '/getSelfAmountRecent'
    },
    {
      name: 'getBidAmountRecent',
      desc: '近七天招标数',
      method: 'GET',
      path: '/getBidAmountRecent'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/screen/index.js